'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/5.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _encyclopedicKnowledge = require('redux/modules/encyclopedicKnowledge');

var encyclopedicKnowledgeActions = _interopRequireWildcard(_encyclopedicKnowledge);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { push } from 'react-router-redux';
// import { Link } from 'react-router';

var EncyclopedicKnowledge = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch(encyclopedicKnowledgeActions.load(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.encyclopedicKnowledge.data,
    dataError: state.encyclopedicKnowledge.error
  };
}, (0, _extends3.default)({}, encyclopedicKnowledgeActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EncyclopedicKnowledge, _Component);

  function EncyclopedicKnowledge() {
    (0, _classCallCheck3.default)(this, EncyclopedicKnowledge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(EncyclopedicKnowledge).call(this));

    _this.state = {
      orderBy: 'time',
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(EncyclopedicKnowledge, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var load = this.props.load;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      switch (clickItem) {
        case 'time':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderBy: 'time',
            orderItem: 'time',
            direction: currentDirection
          });
          break;
        case 'author':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderBy: 'author',
            orderItem: 'author',
            direction: currentDirection
          });
          break;
        default:
          this.setState({
            filter: '',
            orderItem: '',
            direction: '',
            orderBy: 'time'
          });
          currentFilter = '';
          currentDirection = '';
      }
      if (load) {
        load(currentFilter, 0, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var load = this.props.load;
      var _state2 = this.state;
      var orderItem = _state2.orderItem;
      var direction = _state2.direction;
      var filter = _state2.filter;

      if (load) {
        this.setState({
          currentPage: page
        });
        load(filter, page, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var orderBy = this.state.orderBy;

      var styles = require('./EnyclopedicKnowledge.scss');
      var totalPageNumber = 1;
      var encyclopedicKnowledgeDiv = '';
      if (data) {
        var encyclopedicKnowledge = data.encyclopedicKnowledge;
        var encyclopedicKnowledgeError = data.encyclopedicKnowledgeError;
        var encyclopedicKnowledgeRecordCount = data.encyclopedicKnowledgeRecordCount;
        var encyclopedicKnowledgePagesize = data.encyclopedicKnowledgePagesize;

        if (encyclopedicKnowledgeError) {
          encyclopedicKnowledgeDiv = _react2.default.createElement(
            'div',
            { style: { width: '100%', marginLeft: '42px' } },
            'encyclopedicKnowledgeError:' + encyclopedicKnowledgeError
          );
        } else {
          encyclopedicKnowledgeDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%', marginLeft: '42px' } },
            encyclopedicKnowledge instanceof Array && encyclopedicKnowledge.length > 0 ? encyclopedicKnowledge.map(function (knowledge, index) {
              return _react2.default.createElement(_components.EncyclopedicKnowledgeComponent, { key: knowledge.id, index: index, knowledge: knowledge });
            }) : ''
          );
          totalPageNumber = parseInt(encyclopedicKnowledgeRecordCount / encyclopedicKnowledgePagesize, 10);
          if (encyclopedicKnowledgeRecordCount % encyclopedicKnowledgePagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'ul',
          { className: styles.js_ul },
          _react2.default.createElement(
            'li',
            { className: styles.js_li + ' ' + (orderBy === 'time' ? styles.border : ''),
              onClick: function onClick() {
                return _this2.onItemClick('time');
              } },
            '日期'
          ),
          _react2.default.createElement(
            'li',
            { className: styles.js_li + ' ' + (orderBy === 'author' ? styles.border : ''),
              onClick: function onClick() {
                return _this2.onItemClick('author');
              } },
            '作者'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: styles.bk_zs_link }),
        encyclopedicKnowledgeDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return EncyclopedicKnowledge;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  load: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = EncyclopedicKnowledge;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/EncyclopedicKnowledge/EncyclopedicKnowledge.js
 ** module id = 1465
 ** module chunks = 0
 **/